const i = {trigger: '[data-tab-trigger]', panel: '[data-tab-panel]'};
class a extends HTMLElement {
  constructor() {
    super(), (this.elements = {});
  }
  connectedCallback() {
    (this.elements.triggers = this.querySelectorAll(i.trigger)),
      (this.elements.panels = this.querySelectorAll(i.panel)),
      this.elements.triggers.forEach((t) => {
        t.addEventListener('click', this.handleClick.bind(this));
      });
  }
  handleClick(t) {
    t.preventDefault();
    const r = t.currentTarget,
      s = r.getAttribute('aria-controls');
    if (!s) return;
    const n = this.querySelector(`#${s}`);
    n &&
      (this.elements.panels.forEach((e) => {
        e.setAttribute('aria-hidden', e !== n);
      }),
      this.elements.triggers.forEach((e) => {
        e.setAttribute('aria-expanded', e === r);
      }));
  }
}
function c() {
  customElements.define('component-tabs', a);
}
export {c as i};
